module.exports = __webpack_public_path__ + "img/borderRegularHexagonWhite.62a9fffa.svg";